import {
  type BranchKey,
  useForcePushBranchToBaseBranch,
} from '@festina-life/api'
import { Alert } from '@festina-life/ui/feedback'
import { useTranslate } from '@festina-life/ui/hooks'
import { Popover, PopoverButton } from '@festina-life/ui/structure'

import { ActionsMenuPanel } from '../../../actionsPanel/ActionsMenuPanel'
import { OperationsLoadedButton } from '../../../operationsButton/OperationsLoadedButton'
import { PushToBaseBranchButton } from './PushToBaseBranchButton'
import { PushUnavailabilityTooltip } from './PushUnavailabilityTooltip'
import { usePushToBaseBranchAvailability } from './usePushToBaseBranchAvailability'

type Props = {
  branchKey: BranchKey
}

export const ForcePushToBaseBranchButton = ({ branchKey }: Props) => {
  const translate = useTranslate()
  const { isPushVisible, isPushAvailable, unavailableReasons } =
    usePushToBaseBranchAvailability(branchKey)
  const {
    mutateAsync: forcePushBranchToBaseBranch,
    isPending: isForcePushingBranch,
  } = useForcePushBranchToBaseBranch()

  if (!isPushVisible) {
    return null
  }

  return (
    <Popover>
      <PopoverButton as="div">
        <OperationsLoadedButton
          startIcon="status.warning"
          disabled={!isPushAvailable}
          tip={
            unavailableReasons.length ? (
              <PushUnavailabilityTooltip
                unavailableReasons={unavailableReasons}
              />
            ) : undefined
          }
        >
          {translate('branchDetailsPanel.tabs.manage.forcePushToBaseBranch')}
        </OperationsLoadedButton>
      </PopoverButton>
      <ActionsMenuPanel
        anchor={{ to: 'right' }}
        className="max-w-lg! flex flex-col items-end gap-y-2"
      >
        <Alert severity="warning">
          {translate(
            'branchDetailsPanel.tabs.manage.forcePushToBaseBranch.warning',
          )}
        </Alert>
        <PushToBaseBranchButton
          branchKey={branchKey}
          isPushEnabled={isPushAvailable}
          label={translate(
            'branchDetailsPanel.tabs.manage.pushToBaseBranchConfirmation',
          )}
          variant="primary"
          isShowingIcon={false}
          onPush={forcePushBranchToBaseBranch}
          isPending={isForcePushingBranch}
          unavailableReasons={unavailableReasons}
        />
      </ActionsMenuPanel>
    </Popover>
  )
}
